<template>
  <div class="__CRadioButton" :class="{ inline: inline }">
    <q-radio
      :label="label"
      v-model="currentValue"
      :val="val"
      :color="currentColor"
      :disable="disable"
      :dense="dense"
      :size="size"
    />
    <slot />
  </div>
</template>

<script>
import { colorNameFormatter } from '@/lib/tools';

export default {
  name: 'CRadioButton',
  props: {
    value: {
      type: [String, Boolean, Array, Object],
      default: false,
    },
    label: {
      type: String,
    },
    val: {
      type: [String, Object],
    },
    // State
    disable: {
      type: Boolean,
      default: false,
    },

    // Style
    color: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
    },
  },
  computed: {
    currentValue: {
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
      get() {
        return this.value;
      },
    },
    currentColor() {
      return colorNameFormatter(this.color);
    },
  },
};
</script>

<style lang="scss" scoped>
.__CRadioButton {
  &.inline {
    display: inline-block;
  }
}
</style>
